import React, { useRef, useState, useEffect } from "react";
import { Eraser, PenLine } from "lucide-react";

// Firma grafica depositata: canvas disegnabile (mouse + touch). onChange(dataURL|null).
export function SignaturePad({ onChange, height = 160 }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = height * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0A1F44";
  }, [height]);

  const pos = (e) => {
    const c = canvasRef.current;
    const r = c.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - r.left, y: t.clientY - r.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.lineTo(p.x, p.y); ctx.stroke(); setEmpty(false); };
  const end = () => { if (!drawing.current) return; drawing.current = false; if (!empty && onChange) onChange(canvasRef.current.toDataURL("image/png")); };
  const clear = () => { const c = canvasRef.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange && onChange(null); };

  return (
    <div data-testid="signature-pad">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-500 inline-flex items-center gap-1.5"><PenLine className="w-3.5 h-3.5" /> Firma depositata</span>
        <button type="button" onClick={clear} className="inline-flex items-center gap-1 text-xs text-slate-400 hover:text-navy min-h-[44px] px-2" data-testid="signature-clear"><Eraser className="w-3.5 h-3.5" /> Cancella</button>
      </div>
      <canvas ref={canvasRef} style={{ height }} className="w-full rounded-lg border border-hairline bg-white touch-none cursor-crosshair"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
      <p className="text-[11px] text-slate-400 mt-1">Traccia la firma con il dito o il mouse. Sarà conservata come "firma depositata del responsabile".</p>
    </div>
  );
}

export default SignaturePad;
